import { FC, ReactNode, useContext } from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { LayoutContext } from '@shared/contexts/LayoutContext';

interface ViewHeaderProps {
  category: ReactNode;
  title: ReactNode;
  slots?: {
    left?: ReactNode;
    right?: ReactNode;
  };
}

export const ViewHeader: FC<ViewHeaderProps> = ({ category, title, slots }) => {

  const { isDesktop } = useContext(LayoutContext);

  return (
    <Box
      position="sticky"
      top={isDesktop ? 'calc(env(safe-area-inset-top) + 66px)' : 'calc(env(safe-area-inset-top) + 56px)'}
      bgcolor="common.white"
      zIndex={1}
      mb={3}
      borderBottom={theme => `5px solid ${theme.palette.grey[200]}`}
    >
      <Box pl={1} pr={2} py={1.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
          <Stack width="100%" direction="row" alignItems="center" spacing={1}>
            {slots?.left}
            <Box width="100%">
              <Typography variant="subtitle1" color="textSecondary">{category}</Typography>
              <Typography variant="h1">{title}</Typography>
            </Box>
            {slots?.right}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
